import * as React from "react";
import usePermissions from "hooks/usePermissions";
import StepActionButton from "./StepActionButton";
function StepGoToDashboard({ config, actionUrl }) {
  const { dashboard_id } = config;
  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`dashboards:read:${dashboard_id}`);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? "You don't have access to see this dashboard" : void 0,
      title: "Go to Dashboard",
      to: disabled ? null : actionUrl,
      disabled
    }
  );
}
export default StepGoToDashboard;
